<template>
    <div class="has-background-dark" id="board" style="height: 1700px">
        <div v-show="!showEdit" class="has-text-centered  urlPasteBlock" >
            <br>
            <textarea placeholder="paste url here" class="top5 dropUrlTextArea" v-model="goUrl" rows="4"></textarea><br> 
            <button class="button is-coolGreen is-small bottom10"  @click="go">GET</button>
        </div>

        <modal-edit v-show="showEdit" :url="this.compUrl" @close="showEdit = false"></modal-edit>

    </div>
</template>

<script>

import { AZEventBus } from '../components/AZEventBus'
import ModalEdit from '../components/ModalEdit'

export default {
    components: {ModalEdit},

    data: function(){
        return {
          inited: false,
          goUrl: '',
          compUrl: '',
          showEdit: false
        }
    },

    mounted: function(){
      document.getElementById('menuControls').classList.add('hideIt')
      var self = this;
    },

    methods: {
        handleDrop(data, event) {
            event.preventDefault();

            this.compUrl = this.sanitizeURL(event.dataTransfer.getData('URL'))
            this.showEdit = true;

            //console.log(event.dataTransfer.getData('URL'));
        },
        sanitizeURL: function(url){
            var newURL = url.split('://');

            if (newURL.length == 1){
                return  'http://' + url
            }
            return url
        },

        go: function(){

            if(this.goUrl.replace(/[\n\r]+/g, '') == '') return

            var obj = {
                dataTransfer: {}
            };
            obj.dataTransfer.url = this.goUrl.replace(/[\n\r]+/g, '')
            obj.preventDefault = function(){}
            obj.dataTransfer.getData = function(){
                return this.url.replace(/[\n\r]+/g, '');
            }
            this.handleDrop({}, obj);
            this.goUrl = ''
        }
    }
}

</script>